import React from 'react';
import './ScoreCard.css';

function ScoreCard({
  score,
  text,
}) {
  return (
    <div className="card col-xl-3 col-lg-4 col-md-4 col-sm-6 px-0 score-card rounded">
      <div className="card-body px-4 py-2">
        <div className="score-card__score">{score}</div>
        <p className="score-card__description">{text}</p>
      </div>
    </div>
  );
}

export default ScoreCard;
